// ⛔️Generated file. Manual changes will be lost ⛔️

export class UserReasonCodes {
    public static readonly AccountNotFound: string = 'ACCOUNT_NOT_FOUND';
    public static readonly AccountAlreadyExists: string = 'ACCOUNT_ALREADY_EXISTS';
    public static readonly InvalidCode: string = 'INVALID_CODE';
    public static readonly CodeExpired: string = 'CODE_EXPIRED';
    public static readonly TooManyAttempts: string = 'TOO_MANY_ATTEMPTS';
    public static readonly SignInExpired: string = 'SIGN_IN_EXPIRED';
    public static readonly EmailInvalid: string = 'EMAIL_INVALID';
    public static readonly DisplayNameInvalid: string = 'DISPLAY_NAME_INVALID';
    public static readonly ScriptPreferenceInvalid: string = 'SCRIPT_PREFERENCE_INVALID';
    public static readonly TermsNotAccepted: string = 'TERMS_NOT_ACCEPTED';
    public static readonly CodeFormatInvalid: string = 'CODE_FORMAT_INVALID';
}
